import { useCallback, useState } from 'react';

const useOpenedState = (existingState = null) => {
    const [menuOpened, setMenuOpened] = useState(false);
    const openMenu = useCallback(() => {
        setMenuOpened(true);
    }, []);
    const closeMenu = useCallback(() => {
        setMenuOpened(false);
    }, []);
    const toggleMenu = useCallback(() => {
        if (menuOpened) {
            closeMenu();
        } else {
            openMenu();
        }
    }, [openMenu, closeMenu, menuOpened]);

    return existingState !== null
        ? existingState
        : {
              openMenu,
              closeMenu,
              toggleMenu,
              menuOpened,
          };
};

export default useOpenedState;
